import type { ReactNode } from 'react'
import type { Tone } from '@/shared/api/types'

export function Rows({ children }: { children: ReactNode }) {
  return <div className="rows">{children}</div>
}

export function Row({
  tone,
  primary,
  secondary,
  end,
  onClick,
}: {
  tone?: Tone
  primary: ReactNode
  secondary?: ReactNode
  end?: ReactNode
  onClick?: () => void
}) {
  return (
    <div className={`row${onClick ? ' row--link' : ''}`} onClick={onClick}>
      {tone && <span className={`row__sev row__sev--${tone}`} />}
      <div className="row__main">
        <div className="row__t">{primary}</div>
        {secondary && <div className="row__s">{secondary}</div>}
      </div>
      {end && <div className="row__end">{end}</div>}
    </div>
  )
}
